import React from 'react';
import InputCoordinateCard from 'ui-coopeuch-coordinate-card';

// Imagenes
import reloj from '../../../assets/img/reloj-01.svg';
import check from '../../../assets/img/check.svg';


// style
import TcooContendor from './styles';

export const Tcoo = ({
    autorizationSubmit,
    coordenadas,
    setvalues,
    reintentarCoordendas,
    onSumitTcco,
    progressBar,
    tarjeta,
    customHelpers,
    valueCoordenadas,
    statusInput,
    stopTimer,
    tcooCompletado,
    tercerFactorDisp,
}) => {
    const CheckDesafio = () => {
        return (
            <>
                <div className="factor">
                    <p>Busca tu tarjeta de coordenadas <strong>Nº {tarjeta}</strong></p>
                    <p>Luego haz click en “Generar coordenadas” </p>
                </div>
                {/* <div className={progressBar ? "button-generar-tcoo progress-btn active" : "button-generar-tcoo progress-btn"} onClick={onSumitTcco}> */}
                <div className={progressBar ? "button-generar-tcoo progress-btn active" : "button-generar-tcoo progress-btn"} onClick={onSumitTcco}>
                    <div className="btn">{progressBar ? "Generando coordenadas" : "Generar coordenadas"}</div>
                    <div className="progress"></div>
                </div>

                <span className="tiempo-pass-coopeuch">
                    <img src={reloj} alt="reloj" />
                    <strong>02:00</strong> para ingresar tus coordenadas.
                </span>
            </>
        )
    }

    if (coordenadas === "") return <TcooContendor><CheckDesafio /></TcooContendor>
    return (
        <TcooContendor>
            <div className="factor">
              {tcooCompletado ?
                <p>{'¡Coordenadas validadas exitosamente! ' + (tercerFactorDisp ? 'Ahora te solicitaremos el tercer factor de seguridad' : '')}</p>
                : <p>Ingresa las coordenadas indicadas de tu Tarjeta de Coordenadas <strong>Nº {tarjeta}</strong></p>
              }
            </div>
          <div className={tcooCompletado ? 'input-success' : ''}>
            <InputCoordinateCard
                  coordinates={[coordenadas.desafio1, coordenadas.desafio2, coordenadas.desafio3]}
                  values={valueCoordenadas}
                  disabled={statusInput || tcooCompletado}
                  onChange={(e) => { setvalues(e) }}
                  secondsAvailableToRespond={stopTimer?-1:120}
                  loading={false}
                  errorMessage=""
                  customHelper={customHelpers}
                  onTimeOverToRespond={() => { }}
                  onRetryRespond={() => { reintentarCoordendas() }}
            />
            {tcooCompletado && (
              <span className="tiempo-pass-coopeuch">
                <img src={check} alt="check" />
                Las coordenadas ingresadas son correctas.
              </span>
            )}
          </div>
        </TcooContendor>
    );
};
